(() => {
  const form = document.querySelector('#LumiraProjectBrief');
  if (!form) return;
  const requestedProduct = new URL(location.href).searchParams.get('project_product');
  if (requestedProduct && /^[a-z0-9-]{1,180}$/.test(requestedProduct)) {
    form.elements.namedItem('contact[body]').value = 'I would like to plan a matching bedroom around this bed: https://lumirafurn.com/products/' + requestedProduct;
    form.elements.namedItem('contact[project_type]').value = 'Residential design or full-home project';
  }
  document.querySelectorAll('[data-project-preset]').forEach(link => link.addEventListener('click', () => {
    const field = form.elements.namedItem('contact[project_type]');
    const value = link.dataset.projectPreset;
    if ([...field.options].some(option => option.value === value)) field.value = value;
  }));
  // Keep submission, spam protection and confirmation native to Shopify.
})();
